var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page adjust-city-import"},[_c(_vm.currentComponent,{tag:"component",attrs:{"operBatchNumber":_vm.operBatchNumber,"templateType":'IMPORT_CHANGE_CITY'},on:{"onClickCaseDetail":_vm.onClickCaseDetail,"onBackCaseList":function($event){return _vm.onBackCaseList()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }